import Header from '../components/Header';
import Footer from '../components/Footer';
import { Star, ArrowRight, CheckCircle, TrendingUp, Gift } from 'lucide-react';
import { Link } from 'react-router-dom';

const Reviews = () => {
  const reviews = [
    {
      id: 1,
      name: 'Betclic',
      slug: 'betclic',
      bonus: 'Bonus de bienvenue jusqu\'à 100€',
      icon: <Star className="w-8 h-8" />,
      description: 'L\'un des leaders du marché français avec une interface intuitive et des cotes compétitives. Pariez sur le sport et les courses hippiques avec confiance.',
      color: 'from-blue-500 to-blue-700',
      rating: 4.5,
    },
    {
      id: 2,
      name: 'Olybet',
      slug: 'olybet',
      bonus: 'Bonus de bienvenue de 100€',
      icon: <TrendingUp className="w-8 h-8" />,
      description: 'Plateforme moderne offrant une expérience de paris fluide et des promotions régulières. Idéal pour les parieurs recherchant innovation et performance.',
      color: 'from-purple-500 to-purple-700',
      rating: 4.3,
    },
    {
      id: 3,
      name: 'Genybet',
      slug: 'genybet',
      bonus: 'Bonus de bienvenue de 200€ + 50€ de paris gratuits',
      icon: <Gift className="w-8 h-8" />,
      description: 'Spécialiste des paris hippiques avec un bonus généreux et des outils d\'analyse avancés. La référence pour les amateurs de turf et de sport.',
      color: 'from-green-500 to-green-700',
      rating: 4.7,
    },
  ];

  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <Star className="w-16 h-16 text-toxic-green" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Avis & <span className="text-toxic-green">Comparatifs</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Analyses approfondies et indépendantes des meilleures plateformes de paris en ligne en France. Découvrez nos avis détaillés pour faire le bon choix.
            </p>
          </div>

          {/* Reviews Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {reviews.map((review, index) => (
              <article
                key={review.id}
                itemScope
                itemType="http://schema.org/Review"
                className="bg-dark-card border-2 border-gray-800 rounded-2xl overflow-hidden hover:border-toxic-green transition-all transform hover:scale-105 group relative"
              >
                <Link
                  to={`/reviews/${review.slug}`}
                  data-discover="true"
                  itemProp="url"
                  className="block"
                >
                  <div className="absolute top-4 right-4 w-16 h-16 border border-toxic-green opacity-20 rotate-45"></div>
                  
                  <div className="p-8 relative z-10">
                    <div className="mb-6 h-16 flex items-center justify-center">
                      <div className={`w-16 h-16 rounded-lg bg-gradient-to-br ${review.color} flex items-center justify-center text-white`}>
                        {review.icon}
                      </div>
                    </div>

                    <div itemScope itemType="http://schema.org/Product" itemProp="itemReviewed">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-2xl font-bold text-white group-hover:text-toxic-green transition-colors" itemProp="name">
                          {review.name}
                        </h3>
                        <div className="flex items-center" itemScope itemType="http://schema.org/Rating">
                          <Star className="w-5 h-5 text-toxic-green fill-toxic-green" />
                          <span className="ml-1 text-white font-semibold" itemProp="ratingValue">{review.rating}</span>
                          <meta itemProp="bestRating" content="5" />
                          <meta itemProp="worstRating" content="1" />
                        </div>
                      </div>
                    </div>

                    <div className="mb-4 p-4 bg-toxic-green/10 border border-toxic-green/30 rounded-lg">
                      <p className="text-toxic-green font-semibold" itemProp="offers" itemScope itemType="http://schema.org/Offer">
                        <span itemProp="description">{review.bonus}</span>
                      </p>
                    </div>

                    <p className="text-gray-400 mb-6 leading-relaxed" itemProp="description">
                      {review.description}
                    </p>

                    <div className="inline-flex items-center text-toxic-green font-semibold group-hover:text-opacity-80 transition-colors">
                      Lire l'avis complet
                      <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          {/* About Our Reviews Section */}
          <div className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 border-2 border-toxic-green opacity-10 rotate-45 transform translate-x-20 -translate-y-20"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 border-2 border-toxic-green opacity-10 rotate-45 transform -translate-x-16 translate-y-16"></div>
            
            <div className="relative z-10">
              <div className="flex items-center mb-6">
                <CheckCircle className="w-8 h-8 text-toxic-green mr-4" />
                <h2 className="text-3xl md:text-4xl font-bold text-white">
                  Comment Nous Rédigeons Nos Avis
                </h2>
              </div>

              <div className="space-y-6 text-gray-300 leading-relaxed">
                <p className="text-lg">
                  Chaque avis que nous publions est le résultat d'une analyse approfondie et d'un test personnel de la plateforme. Nous ne nous contentons pas de compiler des informations trouvées ailleurs - nous testons réellement chaque aspect de l'expérience utilisateur pour vous donner un avis honnête et détaillé.
                </p>

                <p>
                  Notre processus commence par l'ouverture d'un compte réel sur la plateforme. Nous testons le processus d'inscription, la vérification d'identité, les méthodes de dépôt, l'interface utilisateur, la variété des paris disponibles, la qualité des cotes, le service client, et les processus de retrait. Chaque étape est évaluée selon des critères objectifs : rapidité, simplicité, clarté, et qualité globale.
                </p>

                <p>
                  Nous analysons aussi les conditions générales en détail. Les bonus sont testés pour vérifier que les conditions annoncées correspondent à la réalité. Les restrictions, les limites, les délais - tout est vérifié et documenté. Si une plateforme promet quelque chose mais que la réalité est différente, nous le mentionnons clairement.
                </p>

                <p>
                  La comparaison avec d'autres plateformes est aussi importante. Une plateforme peut être bonne en absolu, mais moins intéressante si d'autres offrent de meilleures conditions. Nous contextualisons toujours nos avis en comparant avec le marché, pour vous aider à comprendre où se situe chaque plateforme.
                </p>

                <p>
                  L'objectivité est au cœur de notre démarche. Bien que nous puissions recevoir des commissions via des liens d'affiliation, cela n'influence jamais nos avis. Si une plateforme présente des faiblesses, nous les mentionnons. Si une offre semble trop belle pour être vraie, nous expliquons pourquoi. Notre réputation dépend de votre confiance, et nous la protégeons en étant toujours transparents.
                </p>

                <p>
                  Nous mettons aussi à jour régulièrement nos avis. Les plateformes évoluent, leurs offres changent, leurs interfaces s'améliorent ou se dégradent. Nous révisons nos avis pour refléter ces changements, et nous indiquons toujours la date de dernière mise à jour. Un avis de 2024 peut ne plus être valide en 2025.
                </p>

                <div className="grid md:grid-cols-3 gap-6 mt-8">
                  <div className="flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-toxic-green flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-white mb-1">Tests Personnels</h3>
                      <p className="text-sm text-gray-400">Chaque plateforme est testée en conditions réelles</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Star className="w-6 h-6 text-toxic-green flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-white mb-1">Objectivité Totale</h3>
                      <p className="text-sm text-gray-400">Nos avis restent indépendants et impartiaux</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <TrendingUp className="w-6 h-6 text-toxic-green flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-white mb-1">Mises à Jour Régulières</h3>
                      <p className="text-sm text-gray-400">Nos avis évoluent avec les plateformes</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Reviews;

